import { Backdrop, CircularProgress, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Tahsilat from 'src/views/DashboardDefault/Todos';
import CustomerActivity from './CustomerActivity';
import Header from './Header';
import WorkOrderList from 'src/components/WorkOrderList'
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  grid: {
    marginTop: theme.spacing(1)
  }
}));

function DashboardDefault() {
  const classes = useStyles();
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(true);
  const [GununOzeti, setGununOzeti] = useState(true);
  const [checked, setChecked] = useState(false);
  const [today, setToday] = useState(1);
  const [todayDisabled, setTodayDisabled] = useState(false);



  const changeChecked = (value) => {
    if(value){ // liste görünümü için dün/bugün ayrımı henüz implement edilmedi. O yüzden bugüne set edip, disable ediyoruz.
      setToday(1);
      setTodayDisabled(true);
    }else{
      setToday(1);
      setTodayDisabled(false);
    }
    setChecked(value);
  }

  var BirimKodu = SessionUser.ServiceShopId;
  var TeknisyenKodu = SessionUser.TechnicianId;
  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetArtemisGununOzeti/' + BirimKodu + '/' + TeknisyenKodu).then((response) => {
        if (mounted) {
          const Deger = response.data;
          setGununOzeti(Deger);
          setLoading(false);
        }
      }).catch(error => {
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [BirimKodu, TeknisyenKodu]);

  return (
    <Page
      className={classes.root}
      title="Default Dashboard"
    >
      <Container maxWidth={false}>
        <Header />
        {
          Loading ?
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Grid
          container
          spacing={3}
          className={classes.grid}
        >
          <Grid
            item
            lg={3}
            sm={6}
            xs={12}
          >
            <CustomerActivity GununOzeti={GununOzeti}
              checked={checked} changeChecked={changeChecked}
              today={today} setToday={setToday} todayDisabled={todayDisabled}/>
          </Grid>
        </Grid>
      </Container>
      {checked ? <WorkOrderList /> : <Tahsilat today={today} />}
    </Page>
  );
}

export default DashboardDefault;
